import { Avatar, Box, Checkbox, Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import stylesLogo from '../Accounts/Account.styles';
import sizeFontCustom from '../Discovery/fontSize.styles';
import { useTranslation } from '../../hooks/useTranslation';
import { getFipDisplayName, getFipLogoAlt } from '../../utils/fipLogo.utils';
import { handleActivationKey, keyboardFocusVisibleSx } from '../../utils/a11y.utils';

function FrequentFip(props) {
	const { t } = useTranslation();
	const { fipId, popular, handleCheckboxChange, selectedFipList } = props;
	const fipName = getFipDisplayName(fipId, t);
	const theme = useTheme();
	const mobileScreen = useMediaQuery(theme.breakpoints.down('md'));

	const isDark =
		props.customDetails?.darkTheme === true || theme.palette.mode === 'dark';
	const isChecked = selectedFipList.includes(fipId);

	const handleRowClick = (event) => {
		if (event.target.closest('.MuiCheckbox-root')) {
			return;
		}
		handleCheckboxChange(
			{
				...event,
				target: { checked: !isChecked, name: fipId },
			},
			fipId,
		);
	};

	return (
		<Grid
			item
			xs={5.75}
			sm={5.75}
			md={5.75}
			lg={2.75}
			padding={
				mobileScreen ? '0.75rem' : popular ? '1rem 1.25rem' : '1rem 1rem'
			}
			sx={{
				display: mobileScreen ? 'flex' : 'block',
				justifyContent: 'space-between',
				alignItems: 'center',
				background: isDark ? '#161616' : theme.palette.primary.white,
				color: isDark ? '#FFFFFF' : '#000000',
				borderRadius: '20px',
				border: isDark ? '1px solid #7A8185' : 'none',
				transition: 'all 0.2s ease-in-out',
				'&:hover': {
					background: isDark ? '#3D3D3D' : '#F5F5F5',
					transform: 'translateY(-2px)',
					boxShadow: isDark
						? '0 4px 8px rgba(0,0,0,0.3)'
						: '0 4px 8px rgba(0,0,0,0.1)',
				},
			}}
		>
			<Box
				onClick={handleRowClick}
				onKeyDown={handleActivationKey(handleRowClick)}
				role="button"
				tabIndex={0}
				aria-label={fipName}
				display="flex"
				justifyContent="space-between"
				alignItems="center"
				width="100%"
				sx={{ cursor: 'pointer', borderRadius: '20px', ...keyboardFocusVisibleSx }}
			>
				<Box sx={{ display: 'flex', alignItems: 'center' }}>
					<Avatar
						alt={getFipLogoAlt(fipId, fipName)}
						src={global.objectFormatFip[fipId]?.productIconUri}
						sx={stylesLogo.avatarStyle}
					/>
					<Typography
						noWrap
						sx={{
							...sizeFontCustom.subHeading,
							color: isDark ? '#FFFFFF' : 'inherit',
							minWidth: 0,
						}}
						textAlign="start"
					>
						{fipName}
					</Typography>
				</Box>
				<Checkbox
					disableTouchRipple
					disableRipple
					name={fipId}
					value={fipId}
					size={mobileScreen ? 'small' : popular ? 'medium' : 'small'}
					sx={{
						height: '18px',
						width: '18px',
						ml: '0.675rem',
						color: isDark ? '#7A8185' : '#D8E1EE',
						'&.Mui-checked': {
							color: props.customDetails?.primaryColor || '#3053D3',
						},
					}}
					checked={isChecked}
					onChange={(event) => handleCheckboxChange(event, fipId)}
					onClick={(event) => event.stopPropagation()}
					inputProps={{ 'aria-label': fipName }}
				/>
			</Box>
		</Grid>
	);
}

export default FrequentFip;
